import React, { useState, useEffect } from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

const ChiliIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block w-5 h-5">
    <path d="M15.252 2.75974L15.952 1.53307C16.2703 0.974908 16.7943 0.563373 17.412 0.386405L18.7253 0.0130712C18.7673 0.000871922 18.8113 -0.00283967 18.8548 0.00215284C18.8983 0.00714534 18.9403 0.020742 18.9785 0.0421502C19.0166 0.0635583 19.0502 0.0923496 19.0771 0.126845C19.104 0.161341 19.1238 0.200851 19.1353 0.243071L19.3186 0.883071C19.3308 0.925093 19.3345 0.969123 19.3295 1.01259C19.3245 1.05607 19.3109 1.09811 19.2895 1.13627C19.2681 1.17443 19.2393 1.20795 19.2048 1.23487C19.1704 1.26179 19.1308 1.28158 19.0886 1.29307L17.7786 1.66974C17.6385 1.70879 17.5075 1.77512 17.3931 1.86493C17.2787 1.95473 17.1832 2.06625 17.112 2.19307L16.4853 3.2864L15.252 2.75974Z" fill="#617A34"/>
    <path d="M17.3972 9.26908C17.3345 9.57878 17.2353 9.87997 17.1019 10.1664C12.4746 20.0731 3.39589 19.5494 0.812559 19.1757C0.611885 19.1483 0.425499 19.0566 0.28129 18.9143C0.137081 18.7721 0.0428015 18.587 0.0125591 18.3867L0.0105591 18.3814C-0.0206478 18.1748 0.0177742 17.9638 0.119769 17.7814C0.221764 17.5991 0.381533 17.4559 0.573892 17.3744C2.17189 16.6744 6.30423 14.2517 9.77123 6.90541C9.92116 6.58547 10.1116 6.28612 10.3379 6.01475L15.3326 4.66675L17.3972 9.26908Z" fill="#E00A29"/>
    <path d="M17.9495 8.35176L17.6495 8.9851C17.5957 9.09818 17.5111 9.19381 17.4054 9.26103C17.2997 9.32826 17.1772 9.36435 17.052 9.36519C16.9268 9.36602 16.8038 9.33156 16.6973 9.26575C16.5907 9.19995 16.5048 9.10545 16.4495 8.9931C16.0811 8.38447 15.9049 7.6788 15.9442 6.96843C15.5649 7.67985 14.9342 8.22449 14.1752 8.4961C13.9438 8.58047 13.6884 8.56959 13.465 8.46585C13.2417 8.36211 13.0686 8.17398 12.9838 7.94276C12.7124 7.18662 12.7309 6.3567 13.0358 5.61343C12.5024 6.10376 11.8322 6.41981 11.1145 6.51943C10.9945 6.54538 10.8697 6.53703 10.7542 6.49534C10.6387 6.45366 10.5373 6.38032 10.4616 6.28372C10.3859 6.18711 10.3388 6.07115 10.3259 5.94907C10.313 5.827 10.3347 5.70375 10.3885 5.59343L10.6292 5.0761C11.0593 4.13516 11.8283 3.39094 12.7829 2.99189C13.7374 2.59284 14.8073 2.56827 15.7792 2.9231C16.291 3.12071 16.7566 3.42175 17.1468 3.8074C17.5371 4.19305 17.8436 4.65503 18.0473 5.16449C18.251 5.67394 18.3474 6.21992 18.3306 6.76832C18.3138 7.31672 18.184 7.85576 17.9495 8.35176Z" fill="#617A34"/>
  </svg>
);

export default function SpiceSelector({ form }) {
  const spice_level = form.watch("spice_level");
  const [showSpice, setShowSpice] = useState(false);

  useEffect(() => {
    setShowSpice(!!spice_level);
  }, [spice_level]);

  const handleSwitchChange = (checked) => {
    setShowSpice(checked);
    if (!checked) {
      form.setValue("spice_level", null);
    }
  };

  const options = [
    { label: "Mild", value: "mild", chilisCount: 0 },
    { label: "Fairly Hot", value: "fairly_hot", chilisCount: 1 },
    { label: "Medium Hot", value: "medium_hot", chilisCount: 2 },
    { label: "Very Hot", value: "very_hot", chilisCount: 3 },
    { label: "Extremely Hot", value: "extremely_hot", chilisCount: 4 },
  ];

  return (
    <div className="w-full flex flex-col gap-3">
      <div className="flex gap-2 items-center">
        <Switch
          checked={showSpice}
          onCheckedChange={handleSwitchChange}
          id="spices-switch"
        />
        <Label htmlFor="spices-switch" className="cursor-pointer">
          Spices <span className="text-sm font-light">(shows on items)</span>
        </Label>
      </div>
      {showSpice && (
        <div className="flex flex-wrap gap-6 p-4 bg-cblack7 rounded-md border border-neutral-700 w-full">
          {options.map((opt) => {
            const isChecked = spice_level === opt.value;
            return (
              <label
                key={opt.value}
                className={`flex items-center gap-3 cursor-pointer select-none text-sm font-medium transition-colors hover:text-white ${
                  isChecked ? "text-cyellow" : "text-cwhite3"
                }`}
              >
                <input
                  type="radio"
                  name="spice_level"
                  value={opt.value}
                  checked={isChecked}
                  onChange={() => form.setValue("spice_level", opt.value)}
                  className="w-4 h-4 bg-neutral-800 border-neutral-600 text-cyellow accent-cyellow focus:ring-cyellow"
                />
                <span className="flex items-center gap-1.5">
                  {opt.chilisCount > 0 && (
                    <span className="flex items-center gap-0.5">
                      {Array.from({ length: opt.chilisCount }).map((_, idx) => (
                        <ChiliIcon key={idx} />
                      ))}
                    </span>
                  )}
                  <span>{opt.label}</span>
                </span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}
